import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './modules/types';
import { DropDownController } from '@/services/request.service';
import { formatTreeData } from '@/utils/utils';
import VueRouter from 'vue-router';

Vue.use(Vuex);
// .filter((item:any)=>item.extraValue!==41)
const store: StoreOptions<RootState> = {
  state: {
    locale: 'zh',
    username: '',
    memberId: 0,
    avatar: '',
    roleType: '',
    isHasDraft: false,
    newMessageNum: 0,
    uniformInfo: {},
    campusList: [],
    countryList: [],
    schoolYearList: [],
    idTypeList: [],
    schoolLibList: [],
    memberShipList: [],
    sourceList: [],
    provinceList: [],
    englishList: [],
    academicQualificationList: [],
    studentTypeList: [],
    schoolYearAndSemesterList: [],
    consultSectionList: [],
    consultSchoolYearAndSemesterList: [],
    router: null,
    schoolYearAndSemesterListStudent:[],
    // newSchoolYearAndSemesterList: [],
    // newConsultSchoolYearAndSemesterList: [],

  },
  mutations: {
    setRouter(state, payload: VueRouter | null) {
      state.router = payload;
    },
    changeLocale(state, payload: string) {
      state.locale = payload;
    },
    setRoleType(state, payload: string) {
      state.roleType = payload;
    },
    setUserInfo(state, payload: { username: string; memberId: number; avatar: string }) {
      const { username, avatar, memberId } = payload;
      state.username = username;
      state.memberId = memberId;
      state.avatar = avatar;
    },
    setDraftFlag(state, payload: boolean) {
      state.isHasDraft = payload;
    },
    setNewMessageNum(state, payload: number) {
      state.newMessageNum = payload;
    },
    setUniformInfo(state, payload: any) {
      state.uniformInfo = payload;
    },
    getCampusList(state, payload): void {
      state.campusList = payload;
    },
    getCountryWithCodeList(state, payload): void {
      state.countryList = payload;
    },
    getSchoolYearList(state, payload): void {
      state.schoolYearList = payload;
    },
    getIdTypeList(state, payload): void {
      state.idTypeList = payload;
    },
    getSchoolLibList(state, payload): void {
      state.schoolLibList = payload;
    },
    getMemberShipList(state, payload): void {
      state.memberShipList = payload;
    },
    getSourceList(state, payload): void {
      state.sourceList = payload;
    },
    getProvinceList(state, payload): void {
      state.provinceList = payload;
    },
    getEnglishList(state, payload): void {
      state.englishList = payload;
    },
    getAcademicQualificationList(state, payload): void {
      state.academicQualificationList = payload;
    },
    getStudentTypeList(state, payload): void {
      state.studentTypeList = payload;
    },
    getSchoolYearAndSemesterList(state, payload): void {
      state.schoolYearAndSemesterList = payload;
    },
    getSchoolYearAndSemesterListStudent(state, payload): void {
      state.schoolYearAndSemesterListStudent = payload;
    },
    getConsultSectionList(state, payload): void {
      state.consultSectionList = payload;
    },
    getConsultSchoolYearAndSemesterList(state, payload): void {
      state.consultSchoolYearAndSemesterList = payload;
    },
   
     reset(state): void {
      state.campusList = [];
      state.countryList = [];
      state.schoolYearList = [];
      state.idTypeList = [];
      state.schoolLibList = [];
      state.memberShipList = [];
      state.sourceList = [];
      state.provinceList = [];
      state.englishList = [];
      state.academicQualificationList = [];
      state.studentTypeList = [];
      state.schoolYearAndSemesterList = [];
      state.consultSectionList = [];
      state.consultSchoolYearAndSemesterList = [];
      state.schoolYearAndSemesterListStudent=[]
      // state.newConsultSchoolYearAndSemesterList=[]
    },
  },
  actions: {
    getCampusList(context): void {
      if (this.state.campusList && this.state.campusList.length === 0) {
        DropDownController.getCampusList().then(res => {
          context.commit('getCampusList', res.data);
        });
      }
    },
    getCountryWithCodeList(context): void {
      if (this.state.countryList && this.state.countryList.length === 0) {
        DropDownController.getCountryWithCodeList().then(res => {
          context.commit('getCountryWithCodeList', res.data);
        });
      }
    },
    getSchoolYearList(context): void {
      if (this.state.schoolYearList && this.state.schoolYearList.length === 0) {
        DropDownController.getSchoolYearList(true).then(res => {
          context.commit('getSchoolYearList', res.data);
        });
      }
    },
    getIdTypeList(context): void {
      if (this.state.idTypeList && this.state.idTypeList.length === 0) {
        DropDownController.getIdTypeList().then(res => {
          context.commit('getIdTypeList', res.data);
        });
      }
    },
    getSchoolLibList(context): void {
      if (this.state.schoolLibList && this.state.schoolLibList.length === 0) {
        DropDownController.getSchoolLibList().then(res => {
          context.commit('getSchoolLibList', res.data);
        });
      }
    },
    getSchoolYearAndSemesterListStudent(context):void{
      if (this.state.schoolYearAndSemesterListStudent && this.state.schoolYearAndSemesterListStudent.length === 0) {
        DropDownController.getSchoolYearAndSemesterList(false).then(res => {
          context.commit('getSchoolYearAndSemesterListStudent', formatTreeData(res.data));
        });
      }
    },
    getMemberShipList(context): void {
      if (this.state.memberShipList && this.state.memberShipList.length === 0) {
        DropDownController.getMemberShipList().then(res => {
          context.commit('getMemberShipList', res.data);
        });
      }
    },
    getSourceList(context): void {
      if (this.state.sourceList && this.state.sourceList.length === 0) {
        DropDownController.getSourceList().then(res => {
          context.commit('getSourceList', res.data);
        });
      }
    },
    getProvinceList(context): void {
      DropDownController.getProvinceList().then(res => {
        context.commit('getProvinceList', res.data);
      });
    },
    getEnglishList(context): void {
      if (this.state.englishList && this.state.englishList.length === 0) {
        DropDownController.getEnglishList().then(res => {
          context.commit('getEnglishList', res.data);
        });
      }
    },
    getAcademicQualificationList(context): void {
      if (this.state.academicQualificationList && this.state.academicQualificationList.length === 0) {
        DropDownController.getAcademicQualificationList().then(res => {
          context.commit('getAcademicQualificationList', res.data);
        });
      }
    },
    getStudentTypeList(context): void {
      if (this.state.studentTypeList && this.state.studentTypeList.length === 0) {
        DropDownController.getStudentTypeList().then(res => {
          context.commit('getStudentTypeList', res.data);
        });
      }
    },
    getSchoolYearAndSemesterList(context): void {
      if (this.state.schoolYearAndSemesterList && this.state.schoolYearAndSemesterList.length === 0) {
        DropDownController.getSchoolYearAndSemesterList(true).then(res => {
          context.commit('getSchoolYearAndSemesterList', formatTreeData(res.data));
        });
      }
    },
    getConsultSectionList(context): void {
      if (this.state.consultSectionList && this.state.consultSectionList.length === 0) {
        DropDownController.getConsultSectionList().then(res => {
          context.commit('getConsultSectionList', res.data);
        });
      }
    },
    getConsultSchoolYearAndSemesterList(context): void {
      if (this.state.consultSchoolYearAndSemesterList && this.state.consultSchoolYearAndSemesterList.length === 0) {
        DropDownController.getSchoolYearAndSemesterList(true).then(res => {
          context.commit('getConsultSchoolYearAndSemesterList', formatTreeData(res.data));
        });
      }
    },
  },
};

export default new Vuex.Store<RootState>(store);
